
<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-text-field
          v-model="value"
          label="员工id"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-btn
          depressed
          color="primary"
          :loading="loading"
          @click="getdata"
        >
          确定
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script route="{path:'/update-token', noChkout: true,justDev:true}" >
  import { http } from '@/libs/util'
  import util from '@/libs/util'


  const { 
    common_dev_auto_login
  } = util.api || {}

  export default {
    data() {
      return {
        value: '',
        loading: false,
      }
    },
    methods: {
      getdata() {
        this.loading = true
        // http.get(common_dev_auto_login, {id: this.value}).then(res => {
        //   this.$Message.success("已成功获取！")
        //   setTimeout(() => {
        //     window.open('/')
        //   }, 500)
        // }).finally(() => {
        //   this.loading = false
        // })
      }
    }
  }
</script>